import { Card } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { Building2, Edit3, MapPin, Users, Percent, CalendarClock, Target } from "lucide-react";
import { num } from "@/lib/api";

const itDate = (s) => {
  if (!s) return "—";
  const p = String(s).slice(0, 10).split("-");
  return p.length === 3 ? `${p[2]}/${p[1]}/${p[0]}` : s;
};

const relStatus = (agency) => {
  if (!agency?.agency_contract) return { label: "Senza contratto", cls: "bg-muted text-muted-foreground border-border" };
  const ds = agency.agency_contract.data_scadenza;
  if (!ds) return { label: "Attiva", cls: "bg-emerald-500/15 text-emerald-400 border-emerald-500/30" };
  const days = Math.ceil((new Date(ds) - new Date()) / 86400000);
  if (days < 0) return { label: "Cessata", cls: "bg-red-500/15 text-red-400 border-red-500/30" };
  if (days <= 60) return { label: "In scadenza", cls: "bg-amber-500/15 text-amber-400 border-amber-500/30" };
  return { label: "Attiva", cls: "bg-emerald-500/15 text-emerald-400 border-emerald-500/30" };
};

const Chip = ({ icon: Icon, label, value }) => (
  <div className="rounded-lg border border-border bg-secondary/40 p-3">
    <div className="flex items-center gap-1.5 font-mono text-[10px] uppercase tracking-wider text-muted-foreground">
      <Icon className="h-3.5 w-3.5" />{label}
    </div>
    <div className="mt-1 text-base font-bold">{value}</div>
  </div>
);

export default function AgencyIdentityBox({ agency, summary, canEdit, onEdit }) {
  const st = relStatus(agency);
  const rel = agency.relazione || {};
  const zona = (agency.regions || []).join(", ") || (agency.provinces || []).join(", ") || "—";
  return (
    <Card data-testid="agency-identity-box" className="border-l-4 border-l-primary p-5">
      <div className="flex flex-wrap items-start justify-between gap-4">
        <div className="flex items-center gap-4">
          <div className="flex h-14 w-14 items-center justify-center rounded-xl bg-primary text-primary-foreground">
            <Building2 className="h-7 w-7" />
          </div>
          <div>
            <div className="flex flex-wrap items-center gap-2">
              <h1 className="font-heading text-2xl font-black tracking-tight sm:text-3xl">{agency.name}</h1>
              <Badge data-testid="agency-status-badge" className={`border ${st.cls}`}>{st.label}</Badge>
            </div>
            <p className="mt-1 flex flex-wrap items-center gap-3 text-sm text-muted-foreground">
              <span className="inline-flex items-center gap-1"><Users className="h-3.5 w-3.5" />{agency.referente || "Referente n/d"}</span>
              <span className="inline-flex items-center gap-1"><MapPin className="h-3.5 w-3.5" />{zona}</span>
            </p>
          </div>
        </div>
        {canEdit && (
          <Button variant="outline" size="sm" onClick={onEdit} data-testid="edit-agency-button">
            <Edit3 className="mr-1.5 h-4 w-4" />Modifica anagrafica
          </Button>
        )}
      </div>
      <div className="mt-4 grid grid-cols-2 gap-3 md:grid-cols-4">
        <Chip icon={Users} label="Clienti" value={num(summary?.partner_assegnati || 0)} />
        <Chip icon={Percent} label="Provvigione mat." value={rel.provvigione_materiale_pct != null ? `${rel.provvigione_materiale_pct}%` : "—"} />
        <Chip icon={CalendarClock} label="Scad. contratto" value={agency.agency_contract?.data_scadenza ? itDate(agency.agency_contract.data_scadenza) : (agency.agency_contract ? "Indet." : "—")} />
        <Chip icon={Target} label="Obiettivo anno" value={rel.obiettivo_annuo != null ? `€ ${Number(rel.obiettivo_annuo).toLocaleString("it-IT")}` : "—"} />
      </div>
    </Card>
  );
}
